import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/vercel/path0/node_modules/gatsby-theme-docz/src/base/Layout.js";
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h2 {...{
      "id": "transfer-ownership"
    }}>{`Transfer Ownership`}</h2>
    <p>{`Transfer of ownership refers to the process of changing the administrative control and responsibility of the online store from one entity or individual to another. This may involve transferring access rights, control over settings, and overall management of the website. The store owner can find the "Transfer Ownership" button beside the "Edit Shop" button from a shop dashboard.
The user can enable the shop maintaience mode while placing a shop tranfer request. `}</p>
    <p><img alt="shop-maintenance" src={require("../images/shop_transfer/transfer_ownership1.png")} /></p>
    <p>{`The store name will be set by default in the "shop name" for ownership transfer. A store owner will be able to transfer shop ownership by selecting a registered vendors name from the dropdown list of "Select a vendor". And send a message towards a vendor from the "Message towards vendor" section. And by clicking on the "Transfer" button a transfer ownership request will be sent to the super admin for approval. `}</p>
    <p><img alt="shop-maintenance" src={require("../images/shop_transfer/transfer_ownership2.png")} /></p>
    <h3 {...{
      "id": "conditions-for-transfering-shop-ownership"
    }}>{`Conditions for Transfering Shop Ownership:`}</h3>
    <ol>
      <li parentName="ol">
        <p parentName="li">{`If a vendor has any pending orders to deliver, the ownership transfer process will not be completed untill the order is delivered. `}</p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`If a vendor has any remaining balance for withdrawal or any pending withdrawal request, then the ownership transfer process will not be proceeded until the withdrawal is completed. `}</p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`The ownership transfer requested will only be accepted until the 'Total Revenue" or available balance becomes Zero ($0). `}</p>
      </li>
      <li parentName="ol">
        <p parentName="li">{`The shop transfer will not be successful if there is a refund order to process. `}</p>
      </li>
    </ol>
    <h3 {...{
      "id": "result-after-transfering-a-shop"
    }}>{`Result after transfering a shop:`}</h3>
    <p>{`Following the transfer of ownership, the transferred owner will see the following scenarios:`}</p>
    <ol>
      <li parentName="ol">{`The shop will initially be inactive after the super admin changes the transfer status to `}<inlineCode parentName="li">{`Processing`}</inlineCode>{`.`}</li>
      <li parentName="ol">{`When the shop transfer state is in `}<inlineCode parentName="li">{`Processing`}</inlineCode>{`, the requested shop will be set to inactive. `}</li>
      <li parentName="ol">{`Every item in the transferred shop's list will be Drafted. `}</li>
      <li parentName="ol">{`When the super admin chnages the status to `}<inlineCode parentName="li">{`Approved`}</inlineCode>{` the shop will be transfered sucessfully to the new owner. `}</li>
    </ol>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      